export const SET_NAME = 'SET_NAME'
export const TOGGLE_DEBUG = 'TOGGLE_DEBUG'
export const SET_IS_FOREGROUND = 'SET_IS_FOREGROUND'

export const SET_LAST_HOME = 'SET_LAST_HOME'
export const SET_LAST_POSTS = 'SET_LAST_POSTS'
export const SET_LAST_GENERAL_REFRESH = 'SET_LAST_GENERAL_REFRESH'

export const RESET_EXPIRATION = 'RESET_EXPIRATION'

export const BASE_PATH = process.env.BASE_PATH || ''
export const CREATE_EVENT_TRY = 'CREATE_EVENT_TRY'
export const CREATE_EVENT_RESPONSE = 'CREATE_EVENT_RESPONSE'
export const CREATE_EVENT_ERROR = 'CREATE_EVENT_ERROR'
export const EDIT_EVENT_TRY = 'EDIT_EVENT_TRY'
export const EDIT_EVENT_RESPONSE = 'EDIT_EVENT_RESPONSE'
export const EDIT_EVENT_ERROR = 'EDIT_EVENT_ERROR'

export const DELETE_EVENT_TRY = 'DELETE_EVENT_TRY'
export const DELETE_EVENT_RESPONSE = 'DELETE_EVENT_RESPONSE'
export const DELETE_EVENT_ERROR = 'DELETE_EVENT_ERROR'

export const UPLOAD_EVENT_IMAGE_TRY = 'UPLOAD_EVENT_IMAGE_TRY'
export const UPLOAD_EVENT_IMAGE_RESPONSE = 'UPLOAD_EVENT_IMAGE_RESPONSE'
export const UPLOAD_EVENT_IMAGE_ERROR = 'UPLOAD_EVENT_IMAGE_ERROR'

export const LOGIN_TRY = 'LOGIN_TRY'
export const LOGIN_RESPONSE = 'LOGIN_RESPONSE'
export const LOGIN_ERROR = 'LOGIN_ERROR'

export const LOGOUT = 'LOGOUT'

export const RESET_PASSWORD_TRY = 'RESET_PASSWORD_TRY'
export const RESET_PASSWORD_RESPONSE = 'RESET_PASSWORD_RESPONSE'
export const RESET_PASSWORD_ERROR = 'RESET_PASSWORD_ERROR'

export const SIGNUP_TRY = 'SIGNUP_TRY'
export const SIGNUP_RESPONSE = 'SIGNUP_RESPONSE'
export const SIGNUP_ERROR = 'SIGNUP_ERROR'
export const SEND_EMAIL_VERIFICATION_TRY = 'SEND_EMAIL_VERIFICATION_TRY'
export const SEND_EMAIL_VERIFICATION_RESPONSE = 'SEND_EMAIL_VERIFICATION_RESPONSE'
export const SEND_EMAIL_VERIFICATION_ERROR = 'SEND_EMAIL_VERIFICATION_ERROR'
export const LOGOUT_TRY = 'LOGOUT_TRY'
export const LOGOUT_RESPONSE = 'LOGOUT_RESPONSE'
export const LOGOUT_ERROR = 'LOGOUT_ERROR'

export const UPDATE_TOKEN_TRY = 'UPDATE_TOKEN_TRY'
export const UPDATE_TOKEN_RESPONSE = 'UPDATE_TOKEN_RESPONSE'
export const UPDATE_TOKEN_ERROR = 'UPDATE_TOKEN_ERROR'

export const GET_LATEST_EVENTS_TRY = 'GET_LATEST_EVENTS_TRY'
export const GET_LATEST_EVENTS_RESPONSE = 'GET_LATEST_EVENTS_RESPONSE'
export const GET_LATEST_EVENTS_ERROR = 'GET_LATEST_EVENTS_ERROR'
export const GET_MY_EVENTS_TRY = 'GET_MY_EVENTS_TRY'
export const GET_MY_EVENTS_RESPONSE = 'GET_MY_EVENTS_RESPONSE'
export const GET_MY_EVENTS_ERROR = 'GET_MY_EVENTS_ERROR'
export const GET_EVENT_TRY = 'GET_EVENT_TRY'
export const GET_EVENT_RESPONSE = 'GET_EVENT_RESPONSE'
export const GET_EVENT_ERROR = 'GET_EVENT_ERROR'

export const ADD_IMAGE_LINK_TO_SERVER_TRY = 'ADD_IMAGE_LINK_TO_SERVER_TRY'
export const ADD_IMAGE_LINK_TO_SERVER_RESPONSE =
  'ADD_IMAGE_LINK_TO_SERVER_RESPONSE'
export const ADD_IMAGE_LINK_TO_SERVER_ERROR = 'ADD_IMAGE_LINK_TO_SERVER_ERROR'

export const GET_IMAGE_DOWNLOAD_LINK_TRY = 'GET_IMAGE_DOWNLOAD_LINK_TRY'
export const GET_IMAGE_DOWNLOAD_LINK_RESPONSE =
  'GET_IMAGE_DOWNLOAD_LINK_RESPONSE'
export const GET_IMAGE_DOWNLOAD_LINK_ERROR = 'GET_IMAGE_DOWNLOAD_LINK_ERROR'

export const UPDATE_INTERESTS = 'UPDATE_INTERESTS'
export const UPDATE_MY_INTERESTS = 'UPDATE_MY_INTERESTS'

export const UPDATE_MY_PROFILE_TRY = 'UPDATE_MY_PROFILE_TRY'
export const UPDATE_MY_PROFILE_RESPONSE = 'UPDATE_MY_PROFILE_RESPONSE'
export const UPDATE_MY_PROFILE_ERROR = 'UPDATE_MY_PROFILE_ERROR'

export const DELETE_MY_PROFILE_TRY = 'DELETE_MY_PROFILE_TRY'
export const DELETE_MY_PROFILE_RESPONSE = 'DELETE_MY_PROFILE_RESPONSE'
export const DELETE_MY_PROFILE_ERROR = 'DELETE_MY_PROFILE_ERROR'

// export const GET_PROFILE_TRY = 'GET_PROFILE_TRY'
// export const GET_PROFILE_RESPONSE = 'GET_PROFILE_RESPONSE'
// export const GET_PROFILE_ERROR = 'GET_PROFILE_ERROR'


export const GET_PUBLIC_PROFILE_TRY = 'GET_PUBLIC_PROFILE_TRY'
export const GET_PUBLIC_PROFILE_RESPONSE = 'GET_PUBLIC_PROFILE_RESPONSE'
export const GET_PUBLIC_PROFILE_ERROR = 'GET_PUBLIC_PROFILE_ERROR'

export const GET_PUBLIC_PROFILES_TRY = 'GET_PUBLIC_PROFILES_TRY'
export const GET_PUBLIC_PROFILES_RESPONSE = 'GET_PUBLIC_PROFILES_RESPONSE'
export const GET_PUBLIC_PROFILES_ERROR = 'GET_PUBLIC_PROFILES_ERROR'

export const GET_MY_PROFILE_TRY = 'GET_MY_PROFILE_TRY'
export const GET_MY_PROFILE_RESPONSE = 'GET_MY_PROFILE_RESPONSE'
export const GET_MY_PROFILE_ERROR = 'GET_MY_PROFILE_ERROR'

export const GET_LATEST_PUBLIC_PROFILES_TRY = 'GET_LATEST_PUBLIC_PROFILES_TRY'
export const GET_LATEST_PUBLIC_PROFILES_RESPONSE = 'GET_LATEST_PUBLIC_PROFILES_RESPONSE'
export const GET_LATEST_PUBLIC_PROFILES_ERROR = 'GET_LATEST_PUBLIC_PROFILES_ERROR'

export const CHANGE_PROFILE_IMAGE_TRY = 'CHANGE_PROFILE_IMAGE_TRY'
export const CHANGE_PROFILE_IMAGE_RESPONSE = 'CHANGE_PROFILE_IMAGE_RESPONSE'
export const CHANGE_PROFILE_IMAGE_ERROR = 'CHANGE_PROFILE_IMAGE_ERROR'
export const REMOVE_ALERT = 'REMOVE_ALERT'
export const TEST_ALERT = 'TEST_ALERT'
export const ADD_ALERT = 'ADD_ALERT'

export const ADD_IMAGE_LINK_TO_PROFILE_TRY = "ADD_IMAGE_LINK_TO_PROFILE_TRY"
export const ADD_IMAGE_LINK_TO_PROFILE_RESPONSE = "ADD_IMAGE_LINK_TO_PROFILE_RESPONSE"
export const ADD_IMAGE_LINK_TO_PROFILE_ERROR = "ADD_IMAGE_LINK_TO_PROFILE_ERROR"

export const CREATE_IMAGE_POST_TRY = "CREATE_IMAGE_POST_TRY"
export const CREATE_IMAGE_POST_RESPONSE = "CREATE_IMAGE_POST_RESPONSE"
export const CREATE_IMAGE_POST_ERROR = "CREATE_IMAGE_POST_ERROR"

export const CREATE_IMAGE_COMMUNITY_TRY = "CREATE_IMAGE_COMMUNITY_TRY"
export const CREATE_IMAGE_COMMUNITY_RESPONSE = "CREATE_IMAGE_COMMUNITY_RESPONSE"
export const CREATE_IMAGE_COMMUNITY_ERROR = "CREATE_IMAGE_COMMUNITY_ERROR"

export const CREATE_IMAGE_EVENT_TRY = "CREATE_IMAGE_EVENT_TRY"
export const CREATE_IMAGE_EVENT_RESPONSE = "CREATE_IMAGE_EVENT_RESPONSE"
export const CREATE_IMAGE_EVENT_ERROR = "CREATE_IMAGE_EVENT_ERROR"

export const CREATE_VIDEO_POST_TRY = "CREATE_VIDEO_POST_TRY"
export const CREATE_VIDEO_POST_RESPONSE = "CREATE_VIDEO_POST_RESPONSE"
export const CREATE_VIDEO_POST_ERROR = "CREATE_VIDEO_POST_ERROR"

export const UPDATE_MY_INTERESTS_TRY = "UPDATE_MY_INTERESTS_TRY"
export const UPDATE_MY_INTERESTS_RESPONSE = "UPDATE_MY_INTERESTS_RESPONSE"
export const UPDATE_MY_INTERESTS_ERROR = "UPDATE_MY_INTERESTS_ERROR"
export const ACCEPT_PRIVACY_POLICIES_TRY = "ACCEPT_PRIVACY_POLICIES_TRY"
export const ACCEPT_PRIVACY_POLICIES_RESPONSE = "ACCEPT_PRIVACY_POLICIES_RESPONSE"
export const ACCEPT_PRIVACY_POLICIES_ERROR = "ACCEPT_PRIVACY_POLICIES_ERROR"

export const FOLLOW_USER_TRY = "FOLLOW_USER_TRY"
export const FOLLOW_USER_RESPONSE = "FOLLOW_USER_RESPONSE"
export const FOLLOW_USER_ERROR = "FOLLOW_USER_ERROR"
export const BLOCK_USER_TOGGLE_TRY = "BLOCK_USER_TOGGLE_TRY"
export const BLOCK_USER_TOGGLE_RESPONSE = "BLOCK_USER_TOGGLE_RESPONSE"
export const BLOCK_USER_TOGGLE_ERROR = "BLOCK_USER_TOGGLE_ERROR"

export const FRIEND_REQUEST_TRY = "FRIEND_REQUEST_TRY"
export const FRIEND_REQUEST_RESPONSE = "FRIEND_REQUEST_RESPONSE"
export const FRIEND_REQUEST_ERROR = "FRIEND_REQUEST_ERROR"
export const FRIEND_REMOVE_TRY = "FRIEND_REMOVE_TRY"
export const FRIEND_REMOVE_RESPONSE = "FRIEND_REMOVE_RESPONSE"
export const FRIEND_REMOVE_ERROR = "FRIEND_REMOVE_ERROR"

export const FRIEND_ACCEPT_TRY = "FRIEND_ACCEPT_TRY"
export const FRIEND_ACCEPT_RESPONSE = "FRIEND_ACCEPT_RESPONSE"
export const FRIEND_ACCEPT_ERROR = "FRIEND_ACCEPT_ERROR"

export const LIKE_EVENT_TRY = "LIKE_EVENT_TRY"
export const LIKE_EVENT_RESPONSE = "LIKE_EVENT_RESPONSE"
export const LIKE_EVENT_ERROR = "LIKE_EVENT_ERROR"
export const ATTEND_EVENT_TRY = "ATTEND_EVENT_TRY"
export const ATTEND_EVENT_RESPONSE = "ATTEND_EVENT_RESPONSE"
export const ATTEND_EVENT_ERROR = "ATTEND_EVENT_ERROR"
export const GET_MY_ACTIVITY_TRY = 'GET_MY_ACTIVITY_TRY'
export const GET_MY_ACTIVITY_RESPONSE = 'GET_MY_ACTIVITY_RESPONSE'
export const GET_MY_ACTIVITY_ERROR = 'GET_MY_ACTIVITY_ERROR'

export const GO_TO_PAGE = 'GO_TO_PAGE'
export const RESET_GO_TO_PAGE = 'RESET_GO_TO_PAGE'
export const RESET_LOADING = 'RESET_LOADING'
export const SET_LOADING = 'SET_LOADING'

export const SEND_RATING_TO_EVENT_TRY = 'SEND_RATING_TO_EVENT_TRY'
export const SEND_RATING_TO_EVENT_RESPONSE = 'SEND_RATING_TO_EVENT_RESPONSE'
export const SEND_RATING_TO_EVENT_ERROR = 'SEND_RATING_TO_EVENT_ERROR'

export const CREATE_POST_TRY = 'CREATE_POST_TRY'
export const CREATE_POST_RESPONSE = 'CREATE_POST_RESPONSE'
export const CREATE_POST_ERROR = 'CREATE_POST_ERROR'

export const FLAG_EVENT_TRY = 'FLAG_EVENT_TRY'
export const FLAG_EVENT_RESPONSE = 'FLAG_EVENT_RESPONSE'
export const FLAG_EVENT_ERROR = 'FLAG_EVENT_ERROR'
export const FLAG_POST_TRY = 'FLAG_POST_TRY'
export const FLAG_POST_RESPONSE = 'FLAG_POST_RESPONSE'
export const FLAG_POST_ERROR = 'FLAG_POST_ERROR'
export const LIKE_ENTRY_TRY = 'LIKE_ENTRY_TRY'
export const LIKE_ENTRY_RESPONSE = 'LIKE_ENTRY_RESPONSE'
export const LIKE_ENTRY_ERROR = 'LIKE_ENTRY_ERROR'
export const SEND_COMMENT_TRY = 'SEND_COMMENT_TRY'
export const SEND_COMMENT_RESPONSE = 'SEND_COMMENT_RESPONSE'
export const SEND_COMMENT_ERROR = 'SEND_COMMENT_ERROR'
export const GET_LATEST_POSTS_TRY = 'GET_LATEST_POSTS_TRY'
export const GET_LATEST_POSTS_RESPONSE = 'GET_LATEST_POSTS_RESPONSE'
export const GET_LATEST_POSTS_ERROR = 'GET_LATEST_POSTS_ERROR'

export const GET_LATEST_POSTS_BY_USER_TRY = 'GET_LATEST_POSTS_BY_USER_TRY'
export const GET_LATEST_POSTS_BY_USER_RESPONSE = 'GET_LATEST_POSTS_BY_USER_RESPONSE'
export const GET_LATEST_POSTS_BY_USER_ERROR = 'GET_LATEST_POSTS_BY_USER_ERROR'

export const GET_ENTRY_TRY = "GET_ENTRY_TRY"
export const GET_ENTRY_RESPONSE = "GET_ENTRY_RESPONSE"
export const GET_ENTRY_ERROR = "GET_ENTRY_ERROR"

export const GET_MORE_POSTS_TRY = 'GET_MORE_POSTS_TRY'
export const GET_MORE_POSTS_RESPONSE = 'GET_MORE_POSTS_RESPONSE'
export const GET_MORE_POSTS_ERROR = 'GET_MORE_POSTS_ERROR'

export const UPLOAD_IMAGE_POST_TRY = 'UPLOAD_IMAGE_POST_TRY'
export const UPLOAD_IMAGE_POST_RESPONSE = 'UPLOAD_IMAGE_POST_RESPONSE'
export const UPLOAD_IMAGE_POST_ERROR = 'UPLOAD_IMAGE_POST_ERROR'

export const UPLOAD_IMAGE_COMMUNITY_TRY = 'UPLOAD_IMAGE_COMMUNITY_TRY'
export const UPLOAD_IMAGE_COMMUNITY_RESPONSE = 'UPLOAD_IMAGE_COMMUNITY_RESPONSE'
export const UPLOAD_IMAGE_COMMUNITY_ERROR = 'UPLOAD_IMAGE_COMMUNITY_ERROR'

export const UPLOAD_IMAGE_EVENT_TRY = 'UPLOAD_IMAGE_EVENT_TRY'
export const UPLOAD_IMAGE_EVENT_RESPONSE = 'UPLOAD_IMAGE_EVENT_RESPONSE'
export const UPLOAD_IMAGE_EVENT_ERROR = 'UPLOAD_IMAGE_EVENT_ERROR'

export const UPLOAD_VIDEO_POST_TRY = 'UPLOAD_VIDEO_POST_TRY'
export const UPLOAD_VIDEO_POST_RESPONSE = 'UPLOAD_VIDEO_POST_RESPONSE'
export const UPLOAD_VIDEO_POST_ERROR = 'UPLOAD_VIDEO_POST_ERROR'

export const FRIEND_INTERACTION_TRY = "FRIEND_INTERACTION_TRY"
export const FRIEND_INTERACTION_RESPONSE = "FRIEND_INTERACTION_RESPONSE"
export const FRIEND_INTERACTION_ERROR = "FRIEND_INTERACTION_ERROR"
export const SEND_FRIEND_REQUEST = 'SEND_FRIEND_REQUEST'
export const CANCEL_FRIEND_REQUEST = 'CANCEL_FRIEND_REQUEST'
export const REMOVE_FRIEND = 'REMOVE_FRIEND'
export const ACCEPT_FRIEND_REQUEST = 'ACCEPT_FRIEND_REQUEST'
export const DECLINE_FRIEND_REQUEST = 'DECLINE_FRIEND_REQUEST'
export const ADD_NOTIFICATIONS_TO_REDUCER = 'ADD_NOTIFICATIONS_TO_REDUCER'
export const GET_LATEST_COMMUNITIES_RESPONSE = "GET_LATEST_COMMUNITIES_RESPONSE"
export const GET_LATEST_COMMUNITIES_ERROR = "GET_LATEST_COMMUNITIES_ERROR"
export const GET_LATEST_COMMUNITIES_TRY = "GET_LATEST_COMMUNITIES_TRY"

export const GET_COMMUNITY_RESPONSE = "GET_COMMUNITY_RESPONSE"
export const GET_COMMUNITY_ERROR = "GET_COMMUNITY_ERROR"
export const GET_COMMUNITY_TRY = "GET_COMMUNITY_TRY"

export const CREATE_COMMUNITY_TRY = "CREATE_COMMUNITY_TRY"
export const CREATE_COMMUNITY_RESPONSE = "CREATE_COMMUNITY_RESPONSE"
export const CREATE_COMMUNITY_ERROR = "CREATE_COMMUNITY_ERROR"

export const GET_MY_COMMUNITIES_TRY = "GET_MY_COMMUNITIES_TRY"
export const GET_MY_COMMUNITIES_ERROR = "GET_MY_COMMUNITIES_ERROR"
export const GET_MY_COMMUNITIES_RESPONSE = "GET_MY_COMMUNITIES_RESPONSE"

export const EDIT_COMMUNITY_TRY = "EDIT_COMMUNITY_TRY"
export const EDIT_COMMUNITY_ERROR = "EDIT_COMMUNITY_ERROR"
export const EDIT_COMMUNITY_RESPONSE = "EDIT_COMMUNITY_RESPONSE"

export const DELETE_COMMUNITY_TRY = "DELETE_COMMUNITY_TRY"
export const DELETE_COMMUNITY_RESPONSE = "DELETE_COMMUNITY_RESPONSE"
export const DELETE_COMMUNITY_ERROR = "DELETE_COMMUNITY_ERROR"

export const UPLOAD_COMMUNITY_IMAGE_TRY = "UPLOAD_COMMUNITY_IMAGE_TRY"
export const UPLOAD_COMMUNITY_IMAGE_ERROR = "UPLOAD_COMMUNITY_IMAGE_ERROR"
export const UPLOAD_COMMUNITY_IMAGE_RESPONSE = "UPLOAD_COMMUNITY_IMAGE_RESPONSE"

export const SEND_RATING_TO_COMMUNITY_TRY = "SEND_RATING_TO_COMMUNITY_TRY"
export const SEND_RATING_TO_COMMUNITY_RESPONSE = "SEND_RATING_TO_COMMUNITY_RESPONSE"
export const SEND_RATING_TO_COMMUNITY_ERROR = "SEND_RATING_TO_COMMUNITY_ERROR"

export const FLAG_COMMUNITY_TRY = "FLAG_COMMUNITY_TRY"
export const FLAG_COMMUNITY_RESPONSE = "FLAG_COMMUNITY_RESPONSE"
export const FLAG_COMMUNITY_ERROR = "FLAG_COMMUNITY_ERROR"
export const JOIN_COMMUNITY_TRY = "JOIN_COMMUNITY_TRY"
export const JOIN_COMMUNITY_RESPONSE = "JOIN_COMMUNITY_RESPONSE"
export const JOIN_COMMUNITY_ERROR = "JOIN_COMMUNITY_ERROR"

export const REMOVE_USER_FROM_COMMUNITY_TRY = "REMOVE_USER_FROM_COMMUNITY_TRY"
export const REMOVE_USER_FROM_COMMUNITY_RESPONSE = "REMOVE_USER_FROM_COMMUNITY_RESPONSE"
export const REMOVE_USER_FROM_COMMUNITY_ERROR = "REMOVE_USER_FROM_COMMUNITY_ERROR"
export const LIKE_COMMUNITY_TRY = "LIKE_COMMUNITY_TRY"
export const LIKE_COMMUNITY_ERROR = "LIKE_COMMUNITY_ERROR"
export const LIKE_COMMUNITY_RESPONSE = "LIKE_COMMUNITY_RESPONSE"

export const DELETE_ENTRY_ERROR = "DELETE_ENTRY_ERROR"
export const DELETE_ENTRY_RESPONSE = "DELETE_ENTRY_RESPONSE"
export const DELETE_ENTRY_TRY = "DELETE_ENTRY_TRY"

export const DELETE_POST_ERROR = "DELETE_POST_ERROR"
export const DELETE_POST_RESPONSE = "DELETE_POST_RESPONSE"
export const DELETE_POST_TRY = "DELETE_POST_TRY"



export const CLEAR_OLD_DATA = "CLEAR_OLD_DATA"

export const NO_ACTION = "NO_ACTION"